import { fg } from '@atlassian/jira-feature-gating';

const SentryErrorMissingFavouriteFiltersRelayProvider = {
	get(): boolean {
		return fg('sea-4064-sentry-error-missing-favouritefilters');
	},
};

export default SentryErrorMissingFavouriteFiltersRelayProvider;
